import CryptoJS from "crypto-js";

export default function aesEncrypt(val: string): string {
  const message: string = val;
  const iv: any = process.env.REACT_APP_AES_IV;
  const key: any =process.env.REACT_APP_AES_KEY;

  const cipher: CryptoJS.lib.CipherParams = CryptoJS.AES.encrypt(message, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC
  });

  return cipher.toString();
}